import React, { useCallback, useState } from "react";
import { LeftNavTabContent } from "../../../../configs/leftNavTabs";
import { ContentWrapper } from "./Styled";
import { ROUTES } from "../../../../configs/routes";
import { useLocation } from "react-router-dom";

type ContentProps = Pick<
    LeftNavTabContent,
    "tabIcon" | "label" | "route" | "routeGroup" | "isCollapsed"
>;

const MemoizedIcon = React.memo(
    ({ icon, isSelected }: any) => {
        return React.cloneElement(icon, { isSelected });
    },
    (prevProps, nextProps) => {
        return prevProps.isSelected === nextProps.isSelected;
    },
);

const Content = ({
    tabIcon,
    label,
    route,
    routeGroup,
    isCollapsed,
}: ContentProps) => {
    const [isSelected, setIsSelected] = useState(false);

    const location = useLocation();

    const activeRoutes = routeGroup?.length ? routeGroup : [route];
    const isInCurrentTab =
        route === ROUTES.Dashboard
            ? location.pathname === ROUTES.Dashboard
            : activeRoutes.some((activeRoute) =>
                  location.pathname.startsWith(activeRoute)
              );

    const onHover = useCallback(() => {
        setIsSelected(true);
    }, [setIsSelected]);

    const exitHover = useCallback(() => {
        setIsSelected(false);
    }, [setIsSelected]);
    return (
        <ContentWrapper
            to={route}
            isSelected={isSelected || isInCurrentTab}
            onMouseEnter={onHover}
            onMouseLeave={exitHover}
            isCollasped={isCollapsed}
        >
            <MemoizedIcon
                key={label}
                icon={tabIcon}
                isSelected={isSelected || isInCurrentTab}
            />
            {!isCollapsed && label}
        </ContentWrapper>
    );
};

export default Content;
